import styled from 'styled-components';

export const StyledSeriesMenuMobile = styled.div`
    width: 100%;
`;
